import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'

import { Seo } from '@/components/generals/seo'

const Boutique = dynamic(() => import('@/components/boutique/boutique'), {
    ssr: false,
    loading: () => <div className='w-full h-screen bg-background' />
})

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo
                title='Resort 2026 Lookbook'
                description='An interactive lookbook of eighteen complete designer outfits. Click any model to magnify the look, browse each piece, and shop the full ensemble.'
            />

            <main className='w-full h-screen overflow-hidden bg-background'>
                <Boutique />
            </main>
        </>
    )
}

export default Home
